import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useSelector } from 'react-redux';
import { isFileExtensionValid } from '../../backend/utils';
import { useDocumentLibraryStorage } from './useDocumentLibraryStorage';
import { useDocumentLibraryTranslations } from './useDocumentLibraryTranslations';
export function useEditDialog() {
    const { t } = useDocumentLibraryTranslations();
    const { fileStorageClient } = useDocumentLibraryStorage();
    const supportedFileTypeSetting = useSelector(getSettings).supportedFileTypes.supportedFileTypes;
    const showEditDialog = (params) => {
        const editDialogForm = {
            type: 'form',
            children: [
                {
                    type: 'form.text',
                    key: 'name',
                    label: t('common.name'),
                    validate: {
                        required: true,
                        custom: (value) => {
                            if (value && !params.file.columns.directory && !isFileExtensionValid(supportedFileTypeSetting, value)) {
                                return t('multipleFilesUpload.unsupportedFileType');
                            }
                            return;
                        },
                    },
                },
                {
                    type: 'form.text',
                    key: 'summary',
                    label: t('multipleFilesUpload.summary'),
                    multiline: true,
                    rows: 4,
                },
            ],
        };
        return showFormDialog({
            title: t('editDialog.title'),
            config: editDialogForm,
            data: {
                name: params.file.columns.name,
                summary: params.file.columns.summary,
            },
            onSubmit: (data) => fileStorageClient
                .post({ action: 'partial-update', id: params.file.id, data: data })
                .then((response) => {
                const fileEntityType = params.fileEntityType;
                showAlertSnackbar({
                    horizontalPosition: 'center',
                    type: 'success',
                    verticalPosition: 'bottom',
                    autoHideDuration: 2000,
                    message: t('editDialog.editSnackbar', { fileEntityType }),
                });
                params.onSuccess(response, data.name, data.summary);
            })
                .catch(handleErrorDialog),
        });
    };
    return { showEditDialog };
}
